import styled from 'styled-components';

// Flexbox container
const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto 20px;
    max-width: 80em;
    text-align: center;
`;

export default Container;
